import { useMemo } from "react";
import type { AnalysisObject, AnalysisVariable } from "@repo/shared";
import { ItemsAnalysisTable } from "./ItemsAnalysisTable";

interface VariablesAnalysisTableProps {
  analysisId: string;
  variables: AnalysisVariable[];
  objects: AnalysisObject[];
}

export function VariablesAnalysisTable({
  analysisId,
  variables,
  objects,
}: VariablesAnalysisTableProps) {
  const rows = useMemo(
    () =>
      variables.map((v) => ({
        id: v.id,
        name: v.name,
        definition: v.definition ?? "",
        usage: v.usageCount,
        used: v.isUsed,
        broken: false,
        indirect: v.isIndirectUsage,
        orphan: v.isOrphanUsageOnly,
        usedIn: v.usedIn,
        issues: v.expressionIssues,
      })),
    [variables],
  );
  return (
    <ItemsAnalysisTable analysisId={analysisId} scope="variables" rows={rows} objects={objects} />
  );
}
